"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4925],{

/***/ 94424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    fullParagraph: segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    backgroundImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/multiple-notes-on-the-wall.png"
    },
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__.AUTO
});


/***/ }),

/***/ 80281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ full_background_text_and_asset; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/default-props.js
var default_props = __webpack_require__(94424);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/full-background-text-and-asset/full-background-text-and-asset.scss.js


var StyledFullBackgroundTextAndAsset = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed876ht0"
})("height:100%;background-size:auto 100%;background-repeat:no-repeat;background-position:center;display:flex;align-items:center;.full-background-text-and-asset-content{margin:0 auto;max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;width:100%;padding:0px 32px;&.top{align-self:flex-start;}&.bottom{align-self:flex-end;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/full-background-text-and-asset/full-background-text-and-asset.js






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var FullBackgroundTextAndAsset = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullBackgroundTextAndAsset, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullBackgroundTextAndAsset);
    function FullBackgroundTextAndAsset() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, FullBackgroundTextAndAsset);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getImageSrc", function() {
            var _props = _this.props, backgroundImage = _props.backgroundImage, assetQuality = _props.assetQuality, useDynamicAsset = _props.useDynamicAsset, clusterConfig = _props.clusterConfig, activePagePath = _props.activePagePath;
            var src = backgroundImage.src;
            var dynamicAssetConfig = useDynamicAsset && (0,cluster_config_service/* getDynamicAssetConfigForPath */.sP)(clusterConfig, activePagePath);
            var url = (dynamicAssetConfig === null || dynamicAssetConfig === void 0 ? void 0 : dynamicAssetConfig.src) || (0,cloudinary_service.generateCloudinaryImageUrl)(src, null, {
                assetQuality: assetQuality
            });
            return "'".concat(url, "'");
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getImageAccessibilityProps", function() {
            var backgroundImage = _this.props.backgroundImage;
            if (!(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.alt)) return {};
            return {
                "aria-label": backgroundImage.alt,
                role: "img"
            };
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(FullBackgroundTextAndAsset, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, fullParagraph = _props.fullParagraph, titleSize = _props.titleSize, textSize = _props.textSize, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, spaceFromParagraph = _props.spaceFromParagraph, topicBottomMargin = _props.topicBottomMargin, buttonTopMargin = _props.buttonTopMargin, paragraphVerticalAlignment = _props.paragraphVerticalAlignment;
                var imageAccessibilityProps = this.getImageAccessibilityProps();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFullBackgroundTextAndAsset, _object_spread_props(_object_spread({
                    className: "full-background-text-and-asset",
                    style: {
                        backgroundImage: "url(".concat(this.getImageSrc(), ")")
                    }
                }, imageAccessibilityProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("full-background-text-and-asset-content", paragraphVerticalAlignment),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({
                            titleSize: titleSize,
                            textSize: textSize,
                            withDynamicParagraphTitle: withDynamicParagraphTitle,
                            withDynamicParagraphSubtitle: withDynamicParagraphSubtitle,
                            spaceFromParagraph: spaceFromParagraph,
                            topicBottomMargin: topicBottomMargin,
                            buttonTopMargin: buttonTopMargin
                        }, fullParagraph))
                    })
                }));
            }
        }
    ]);
    return FullBackgroundTextAndAsset;
}(react.PureComponent);
FullBackgroundTextAndAsset.defaultProps = default_props/* default */.Z;
/* harmony default export */ var full_background_text_and_asset = ((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(FullBackgroundTextAndAsset)));


/***/ }),

/***/ 54925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ full_background_text_and_asset_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/full-background-text-and-asset.js + 1 modules
var full_background_text_and_asset = __webpack_require__(80281);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/default-props.js
var default_props = __webpack_require__(94424);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/full-background-text-and-asset-component.scss.js
var componentStyles = new String(".full-background-text-and-asset-component.jsx-1ac5dfb0b46a53c2{height:650px;&.jsx-1ac5dfb0b46a53c2:not(.align-to-logo){.full-background-text-and-asset-content{padding:0 96px}}}");
componentStyles.__hash = "1ac5dfb0b46a53c2";

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/full-background-text-and-asset-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var FullBackgroundTextAndAssetComponent = function(props) {
    var height = props.height, alignToLogo = props.alignToLogo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: height
        },
        className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("full-background-text-and-asset-component", {
            "align-to-logo": alignToLogo
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_background_text_and_asset/* default */.Z, _object_spread({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
FullBackgroundTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    titleSize: sizes.MD,
    textSize: sizes.MD,
    height: "650px",
    alignToLogo: true
});
/* harmony default export */ var full_background_text_and_asset_component = (FullBackgroundTextAndAssetComponent);


/***/ })

}]);